import { Container, makeStyles } from '@material-ui/core';
import React from 'react';
import { AnimatedSocialIcon } from 'react-animated-social-icons';

const useStyle = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    padding: 0,
    marginTop: '3em',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingRight: '6.5em',
    width: '100%',
    '& > a': {
      zIndex: 99,
      width: '5.5em',
      padding: '4em',
    },
    [theme.breakpoints.down('md')]: {
      '& > a': {
        width: '3.5em',
        padding: '3em',
      },
    },

    [theme.breakpoints.down('sm')]: {
      '& > a': {
        width: '3em',
        padding: '2.5em',
      },
    },
  },
}));

const MySocialMedias = () => {
  const classes = useStyle();
  return (
    <div className={classes.container}>
      <AnimatedSocialIcon
        brandName="github"
        url="https://github.com/juan-cantero"
        animation="bounce"
        defaultColor="#D1D1D1"
        hoverColor="black"
        animationDuration={0.8}
      />

      <AnimatedSocialIcon
        brandName="twitter"
        url="https://twitter.com/juanquicantero"
        animation="float"
        defaultColor="#D1D1D1"
        hoverColor="#1DA1F2"
        animationDuration={0.8}
      />

      <AnimatedSocialIcon
        brandName="linkedin"
        url="https://linkedin.com/in/juancantero89"
        animation="grow"
        defaultColor="#D1D1D1"
        hoverColor="#444"
        animationDuration={0.8}
      />

      <AnimatedSocialIcon
        brandName="discord"
        url="https://discord.com/users/juan-cantero"
        animation="sink"
        defaultColor="#D1D1D1"
        hoverColor="#7289da"
        animationDuration={0.3}
      />

      <AnimatedSocialIcon
        brandName="spotify"
        url="https://open.spotify.com/user/reyleonj?si=6ufchMHuQ12K6pIkJMFJKQ"
        animation="bounce"
        defaultColor="#D1D1D1"
        hoverColor="#1DB954"
        animationDuration={0.3}
      />
    </div>
  );
};

export default MySocialMedias;
